import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import { collections } from "../data/site";
import gallery from "../data/gallery";

export default function Collections() {
  return (
    <>
      <PageHero
        eyebrow="The Collections"
        title="Diamonds & premium CZ"
        subtitle="Three signature expressions of Culture Diamond Jewels — lab-grown diamonds, natural diamond jewellery and premium CZ."
        image="/assets/cd/prod-tennis-navy.jpg"
      />

      {/* Signature collections — alternating rows */}
      <section className="py-24 md:py-28">
        <div className="container-luxe space-y-24 md:space-y-32">
          {collections.map((c, i) => (
            <div
              key={c.id}
              className={`grid items-center gap-12 lg:grid-cols-2 lg:gap-20 ${
                i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""
              }`}
            >
              <Reveal className="overflow-hidden">
                <img
                  src={c.image}
                  alt={c.name}
                  className="h-[400px] w-full object-cover sm:h-[500px] lg:h-[560px]"
                />
              </Reveal>
              <Reveal delay={150}>
                <p className="eyebrow mb-5">0{i + 1} — Collection</p>
                <h2 className="section-title mb-6">{c.name}</h2>
                <p className="max-w-md font-sans text-base font-light leading-relaxed text-charcoal/70">
                  {c.blurb}
                </p>
                <Link to="/contact" className="btn-gold mt-9">
                  Enquire
                </Link>
              </Reveal>
            </div>
          ))}
        </div>
      </section>

      {/* Themed editorials from the gallery */}
      <section className="border-t border-gold/15 bg-cream py-24">
        <div className="container-luxe">
          <Reveal className="mb-14 text-center">
            <p className="eyebrow mb-5">Seasonal Editorials</p>
            <h2 className="section-title">The latest themes</h2>
          </Reveal>
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {gallery.map((theme, i) => (
              <Reveal key={theme.id} delay={i * 100}>
                <Link to="/gallery" className="group block">
                  <div className="relative overflow-hidden">
                    <img
                      src={theme.posts.find((p) => p.type === "image")?.src || theme.grid}
                      alt={theme.title}
                      className="h-80 w-full object-cover transition-transform duration-[1200ms] group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-charcoal/90 to-transparent" />
                    <div className="absolute inset-x-0 bottom-0 p-5 text-cream">
                      <h3 className="font-serif text-xl font-light">{theme.title}</h3>
                      <p className="mt-1 font-sans text-xs font-light text-cream/70">
                        {theme.description}
                      </p>
                    </div>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
